export const isShopTheLookEnabled = (shopTheLookBrandConfig, partNumber, breadcrumb) => {
  const {
    SHOP_THE_LOOK_ENABLED = false,
    SHOP_THE_LOOK_EXCLUDED_CATEGORIES = [],
    SHOP_THE_LOOK_EXCLUDED_SKUS = [],
    SHOP_THE_LOOK_ONLY_INCLUDED_CATEGORIES = []
  } = shopTheLookBrandConfig || {}

  // Enabled in brand config
  if (!SHOP_THE_LOOK_ENABLED) return false

  // Included categories only
  if (
    SHOP_THE_LOOK_ONLY_INCLUDED_CATEGORIES.length &&
    !SHOP_THE_LOOK_ONLY_INCLUDED_CATEGORIES.includes(breadcrumb[0]?.name)
  ) {
    return false
  }

  // Excluded categories
  if (
    SHOP_THE_LOOK_EXCLUDED_CATEGORIES.length &&
    (SHOP_THE_LOOK_EXCLUDED_CATEGORIES.includes(breadcrumb[1]?.name) ||
      SHOP_THE_LOOK_EXCLUDED_CATEGORIES.includes(breadcrumb[2]?.name))
  ) {
    return false
  }

  // Excluded SKUs
  if (SHOP_THE_LOOK_EXCLUDED_SKUS.length && SHOP_THE_LOOK_EXCLUDED_SKUS.includes(partNumber)) {
    return false
  }

  return true
}
